export default __webpack_public_path__ + "static/media/IMG_5520.0377befa.JPG";